module.exports = __webpack_public_path__ + "static/media/dresses.983e369d.webp";